<!--
 * @Author:
 * @Description:步骤1-验证你的业务
 * @Date: 2024-09-09 14:11:44
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-companyType.vue
-->
<template>
  <div class="step_companyType">
    <div>
      <p class="descript1"> {{ $t('message.register.validateBusiness.companyType.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.companyType.descript2') }}</p>

    </div>
    <validation-component ref="validationForm" :validation-condition="validationCondition">
    </validation-component>

    <div class="button-box">
      <el-button type="primary" @click="confirm" size="medium" :disabled="isDisabled">{{ $t('message.exchange.continue')
        }}</el-button>
    </div>
  </div>
</template>

<script>
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { businessLocation, TypeofBusinessList } from '@/utils/options/networkApplication';

import mixin from '../../mixins';
export default {
  name: 'StepCompanyType',
  components: {
    ValidationComponent,
  },
  mixins: [mixin],
  data() {
    return {
      validationCondition: [
        {
          key: 'businessLocation',
          name: 'message.register.businessLocation',
          type: 'select',
          placeholder: 'message.register.businessTypeTips',
          defValue: '',
          options: businessLocation,
          isInternationalization: true,
          changeValue: this.businessLocationcChangeValue,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'typeOfBusiness',
          name: 'message.register.typeOfBusiness',
          type: 'select',
          defValue: '',
          placeholder: 'message.register.businessTypeTips',
          isInternationalization: true,
          options: [],
          isShowStar: true,
          rule: [],
        },
        {
          key: 'referrer',
          name: 'message.register.companType.referrer',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.companType.referrer_placeHolder',
          isInternationalization: true,
          options: [],
          isShowStar: true,
          rule: [],
        },
      ],
    };
  },
  methods: {
    businessLocationcChangeValue(value) {
      const options = TypeofBusinessList.filter(item => item.link === value) || [];
      this.validationCondition.find(item => item.key === 'typeOfBusiness').options = options;
    },
    confirm() {
      this.$refs.validationForm.toFormValid((businessType) => {
        this.$emit('updateFormData', { businessType, currentStep: 'businessType', nextStep: 'businessDetails' });
      });
    },
  },
  watch: {
    applicationInfo: {
      // TODO:本来是想和上面confirm写在一起的
      handler(applicationInfo) {
        const { businessType, businessType: { businessLocation }, currentStep } = applicationInfo;
        const isDisabled = currentStep === 'status';
        if (isDisabled) {
          this.$refs.validationForm.setItemDisabled('', true, true);
        }
        this.businessLocationcChangeValue(businessLocation);
        ['businessLocation', 'typeOfBusiness', 'referrer'].forEach(key => {
          this.$refs.validationForm.setItemValue(key, businessType[key]);
        });
        this.$nextTick(() => {
          this.$refs.validationForm.toFormValid((_businessType) => {
            this.$emit('onlyUpdateForm', { businessType: _businessType, currentStep: 'businessType' });
          });
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}
</style>
